import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const CaymanIslands: Country = {
    identifier: "CaymanIslands",
    name: "Cayman Islands",
    countryCode: "KY",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇰🇾",
    svgPath: "m 250.87175,406.8394 -0.131,0.045 -0.102,-0.018 0.23,-0.123 0.059,-0.042 0.051,-0.022 0.053,0 0.067,0.025 0,0.019 -0.227,0.116 z m -0.436,0.011 -0.028,0.017 -0.09,-0.013 -0.206,0.121 -0.089,-0.007 0.027,-0.042 0.043,-0.04 0.048,-0.029 0.045,-0.012 0.144,-0.024 0.068,-0.003 0.047,0.027 -0.009,0.005 z m -3.903,1.063 0.091,0.057 0.114,-0.035 0.033,-0.063 0.433,0.046 0.065,0.123 -0.33,0.003 -0.148,0.079 -0.074,0.016 -0.283,-0.019 -0.041,-0.285 0.079,-0.03 0.061,0.108 z",
}
